import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';
import getTranslatedText from '../../../../helper/get_translated_text';

function LowStock({ stock, onNotifyMeClick, productType }) {
    const type = productType === 'wheel' ? 'wheels' : 'tyres';
    const productCategory = getTranslatedText(type).toLowerCase();
    return (
        <p className="product-tile__low-stock-notification product-tile__notification" onClick={onNotifyMeClick}>
            <span className="product-tile__stock-notification-label">
                <Translation translationKey="product-tile-notification-label-low-stock"
                    placeholder={{ stock, productType: productCategory }} />
            </span>
            <span className="product-tile__notify-on-restock">
                <Translation translationKey="product-tile-notification-action-low-stock" />
            </span>
        </p>
    );
}

LowStock.propTypes = {
    stock: PropTypes.number.isRequired,
    onNotifyMeClick: PropTypes.func.isRequired,
    productType: PropTypes.string.isRequired,
};

export default LowStock;
